import Field from "@/Field";
import { FieldProps } from "@/Field/Field";
import Menu from "@/Menu";
import MenuItem from "@/MenuItem";
import {
  CountryIso2,
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";
import React from "react";

type PhoneFieldProps = Pick<
  FieldProps,
  "label" | "required" | "name" | "placeholder" | "error" | "colSpan"
  // | "onChange"
> & {
  value?: string;
  onChange: (phone: string) => void;
  defaultCountry?: CountryIso2;
};

const PhoneField = (props: PhoneFieldProps) => {
  const { value, onChange, defaultCountry, ...rest } = props;
  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
    usePhoneInput({
      defaultCountry: defaultCountry || "us",
      value,
      countries: defaultCountries,
      onChange: ({ phone }) => {
        onChange(phone);
      },
    });

  // // Add this effect to update country when defaultCountry changes
  // React.useEffect(() => {
  //   if (defaultCountry) {
  //     setCountry(defaultCountry, { focusOnInput: false });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [defaultCountry]);

  return (
    <Field
      type="tel"
      value={inputValue}
      ref={inputRef}
      //@ts-ignore
      onChange={handlePhoneValueChange}
      startAdornment={
        <Menu
          label={<FlagImage iso2={country.iso2 as CountryIso2} size="25px" />}
          className="!pl-2 !pr-2 focus-visible:!outline-none"
          align="start"
          title="Selected country"
        >
          {defaultCountries.map((c) => {
            const country = parseCountry(c);
            return (
              <MenuItem
                key={country.iso2}
                onClick={() => setCountry(country.iso2 as CountryIso2)}
                className="items-center gap-2"
              >
                <FlagImage iso2={country.iso2 as CountryIso2} size="25px" />
                {country.name}
              </MenuItem>
            );
          })}
        </Menu>
      }
      {...rest}
    />
  );
};

export default PhoneField;
